export const arrayHelper = {
  getRandom: <T>(array: T[]): T => {
    return array[Math.floor(Math.random() * array.length)];
  },
};

export default arrayHelper;
